var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownwardArrowGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "6px",
    viewBox: "0 0 9 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_Dropdown") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KnowledgeBase-99---Interactions",
    transform: "translate(-1531.000000, -942.000000)",
    fill: "#8A97A0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header",
    transform: "translate(-17.000000, 896.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NAV--01-/-KB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User",
    transform: "translate(1359.000000, 31.343750)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16x16/ArrowSmall_Down",
    transform: "translate(185.000000, 9.083333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3258827,8.35638677 L10.1727875,11.2352793 C10.432973,11.4983882 10.4306031,11.9226021 10.1674942,12.1827876 C9.90438527,12.4429731 9.48017136,12.4406032 9.21998588,12.1774942 L5.9072081,8.82749425 C5.77798779,8.69682202 5.7135289,8.52641192 5.71360893,8.35609346 C5.71352895,8.18636147 5.77798784,8.01595146 5.9072081,7.88527929 L9.21998588,4.53527929 C9.48017136,4.27217038 9.90438527,4.26980047 10.1674942,4.52998595 C10.4306031,4.79017142 10.432973,5.21438534 10.1727875,5.47749425 L7.3258827,8.35638677 Z",
    id: "icon",
    transform: "translate(8.040000, 8.356387) scale(-1, -1) rotate(90.000000) translate(-8.040000, -8.356387) "
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownwardArrowGrey);
export default __webpack_public_path__ + "static/media/Downward_Arrow_Grey.febd887de8b8b51a9fedad385ffbc365.svg";
export { ForwardRef as ReactComponent };